module.exports = __webpack_public_path__ + "Flag-360.40f1a41e6025a2753ec4444e641492e7.svg";